export default "__VITE_ASSET__CAQoqMFD__"